<template>
  <div class="page">
    <!-- Fondo gradiente -->
    <div class="background"></div>

    <!-- Card centrada -->
    <div class="card-wrap">
      <!-- Logo circular centrado y sobresaliente -->
      <div
        class="logo-pill"
        :style="{ backgroundImage: 'url(' + logoUrl + ')' }"
        role="img"
        aria-label="Logo institucional"
      ></div>

      <!-- Columna para dispositivos grandes (md y superiores) -->
      <!-- Contenido elevado -->
      <div class="card-elevated">
        <div class="panel">
          <!-- Lado imagen -->
          <div class="panel-left">
            <div
              class="image"
              :style="{ backgroundImage: 'url(' + heroImageUrl + ')' }"
            >
              <!-- opcional text over image -->
              <div class="image-caption" style="align-content: first baseline">
                <h3>Biblioteca Virtual</h3>
                <p>
                  Plataforma piloto para miembros hábiles y vitalicios. Cupos
                  limitados.
                </p>
                <div
                  class="alert alert-dismissible fade show cupos"
                  role="alert"
                >
                  Cupos Disponibles : {{ cupos }}
                  <button
                    type="button"
                    class="btn-close"
                    data-bs-dismiss="alert"
                    aria-label="Close"
                  ></button>
                </div>
              </div>
            </div>
          </div>

          <!-- Lado formulario -->
          <div class="panel-right">
            <div class="intro">
              <h2>Inscripción - Biblioteca Virtual</h2>
            </div>

            <form @submit.prevent="buscarColegiado" class="form">
              <!-- Campos de búsqueda -->
              <div class="form-group">
                <label for="documento"
                  >Documento de Identidad del Miembro de la Orden</label
                >
                <div style="display: flex; gap: 20px; align-items: center">
                  <input
                    v-model="documento"
                    id="documento"
                    type="text"
                    :disabled="docDisabled"
                    aria-describedby="documentoHelp"
                    class="form-control"
                  />
                  <button
                    type="submit"
                    class="btn primary"
                    aria-label="Buscar colegiado"
                  >
                    Buscar
                  </button>
                </div>

                <div id="documentoHelp" class="help">
                  *Recuerda estar hábil para inscribirte
                </div>
              </div>

              <!-- Campos de información del colegiado (siempre deshabilitados) -->
              <div class="form-group" style="gap: 10px">
                <label for="nombre">Nombre</label>
                <input
                  v-model="nombre"
                  type="text"
                  class="form-control"
                  id="nombre"
                  aria-describedby="nombreHelp"
                  disabled
                />
              </div>

              <div class="form-group two">
                <div>
                  <label for="estado" style="margin-bottom: 10px">Estado</label>
                  <input
                    v-model="estado"
                    id="estado"
                    type="text"
                    class="form-control"
                    disabled
                    aria-describedby="estadoHelp"
                  />
                </div>

                <div>
                  <label for="codigoColegiado" style="margin-bottom: 10px"
                    >Código Colegiado</label
                  >
                  <input
                    v-model="codigoColegiado"
                    id="codigoColegiado"
                    type="text"
                    class="form-control"
                    disabled
                    aria-describedby="codigoColegiadoHelp"
                  />
                </div>
              </div>

              <div class="form-group two">
                <div>
                  <label for="celCollegiate" style="margin-bottom: 10px"
                    >Celular</label
                  >
                  <input
                    v-model="celular"
                    id="celCollegiate"
                    type="text"
                    class="form-control"
                    aria-describedby="celCollegiateHelp"
                    @blur="celTouched = true"
                  />
                  <div v-if="celTouched && celCollegiateError" class="error">
                    El celular debe tener 9 dígitos y comenzar con 9.
                  </div>
                </div>

                <div>
                  <label for="emailCollegiate" style="margin-bottom: 10px"
                    >Correo Electrónico</label
                  >
                  <input
                    v-model="email"
                    id="emailCollegiate"
                    type="email"
                    class="form-control"
                    aria-describedby="emailCollegiateHelp"
                    @blur="emailTouched = true"
                  />
                  <div
                    v-if="emailTouched && emailCollegiateError"
                    class="error"
                  >
                    Por favor, ingrese un email válido.
                  </div>
                </div>
              </div>

              <!-- Botón de inscripción -->

              <div class="actions-row final">
                <div style="display: flex; gap: 12px">
                  <button
                    @click.prevent="crearAsistente"
                    :disabled="!isFormValid"
                    class="btn primary"
                  >
                    Inscribirse
                  </button>

                  <button
                    @click.prevent="limpiarCampos"
                    type="button"
                    class="btn ghost"
                  >
                    Limpiar
                  </button>
                </div>
              </div>

              <!-- <button
                @click.prevent="crearAsistente"
                class="btn btn-success"
                :disabled="!isFormValid"
              >
                > Inscribirse
              </button>
              <button
                @click.prevent="limpiarCampos"
                class="btn btn-primary mx-4"
              >
                Limpiar
              </button> -->
            </form>
          </div>
        </div>
      </div>
      <!-- Info extra (opcional) debajo del card -->
      <div class="credit">
        <small
          >Consejo Directivo 2024-2025 — Colegio de Contadores Públicos de La
          Libertad</small
        >
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import Swal from "sweetalert2";

export default {
  data() {
    return {
      logoUrl: "https://ccpll.org/assets/img/logo_solo.png", // cambia aquí
      heroImageUrl:
        "https://images.unsplash.com/photo-1529070538774-1843cb3265df?q=80&w=1400&auto=format&fit=crop&ixlib=rb-4.0.3&s=placeholder", // cambia aquí

      documento: "",
      docDisabled: false,
      nombre: "",
      estado: "",
      codigoColegiado: "",
      celular: "",
      email: "",
      apiUrl: "",
      cupos: 0,
      celTouched: false,
      emailTouched: false,
    };
  },
  computed: {
    celCollegiateError() {
      return !/^9\d{8}$/.test(this.celular); // Valida que el celCollegiate tenga 9 dígitos y comience con 9
    },
    emailCollegiateError() {
      return !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(this.email); // Valida que el emailCollegiate sea válido
    },
    isFormValid() {
      return (
        !this.celCollegiateError &&
        !this.emailCollegiateError &&
        this.celular &&
        this.email
      );
    },
  },
  created() {
    if (process.env.NODE_ENV === "production") {
      this.apiUrl = "https://inscripcionbibliotecaapi.ccpll.org/api";
    } else {
      this.apiUrl = "http://localhost:8000/api";
      // this.apiUrl = "https://inscripcionbibliotecaapi.ccpll.org/api";
    }
  },
  mounted() {
    this.cuposRestantes();
  },
  methods: {
    cuposRestantes() {
      axios
        .get(`${this.apiUrl}/contarColegiados`)
        .then((response) => {
          this.cupos = 2514 - response.data;
        })
        .catch(() => {});
    },
    buscarColegiado() {
      Swal.fire({
        title: "Buscando información...",
        html: "Por favor, espera un momento mientras se buscan los datos.",
        allowOutsideClick: false,
        showConfirmButton: false,
        didOpen: () => Swal.showLoading(),
      });
      axios
        .get(`https://server.ccpll.org/api/listcolegiados/${this.documento}`)
        //.get(`https://admin-ccpll.org/api/v1/colegiado-estado/${this.documento}` )

        .then((response) => {
          const data = response.data;

          if (!data || Object.keys(data).length === 0) {
            Swal.fire("Error", "Colegiado no encontrado.", "error");
            this.limpiarCampos();
            return;
          }

          this.nombre = response.data._DATOS_PERSONALES;
          this.estado = response.data._ESTADO_COLEGIADO;
          this.codigoCollegiate = response.data._CODIGO;
          Swal.fire("Éxito", "Información encontrada con éxito.", "success");
          this.docDisabled = true;
        })
        .catch(() => {
          Swal.fire("Error", "No se pudo buscar el colegiado.", "error");
        });
    },
    crearAsistente() {
      if (!this.isFormValid) {
        Swal.fire("Error", "Corrige los errores en el formulario.", "error");
        return;
      }
      Swal.fire({
        title: "Procesando...",
        html: "Por favor, espera un momento.",
        allowOutsideClick: false,
        showConfirmButton: false,
        didOpen: () => Swal.showLoading(),
      });
      axios
        .post(`${this.apiUrl}/crearAsistente`, {
          condicion: this.estado,
          doiCollegiate: this.documento,
          nameCollegiate: this.nombre,
          codigoColegiado: this.codigoColegiado,
          celCollegiate: this.celular,
          emailCollegiate: this.email,
        })
        .then((response) => {
          const msg =
            response.data && response.data.mensaje
              ? response.data.mensaje
              : "Registro realizado con éxito.";
          Swal.fire("Éxito", msg, "success");
          this.limpiarCampos();
        })
        .catch((error) => {
          console.log("axios error: ", error);

          if (error.response && error.response.data) {
            const serverMsg =
              error.response.data.mensaje ||
              error.response.data.message ||
              (error.response.data.errors &&
                JSON.stringify(error.response.data.errors)) ||
              "Error, inténtalo de nuevo.";
            Swal.fire("Error", serverMsg, "error");
          } else if (error.request) {
            Swal.fire("Error", "No se pudo completar el registro.", "error");
          } else {
            Swal.fire(
              "Error",
              "Ocurrió un error al procesar la petición.",
              "error"
            );
          }

          // Swal.fire("Error", "No se pudo completar el registro.", "error");
        });
    },
    limpiarCampos() {
      this.documento = "";
      this.nombre = "";
      this.estado = "";
      this.codigoColegiado = "";
      this.celular = "";
      this.email = "";
      this.docDisabled = false;
      this.celTouched = false;
      this.emailTouched = false;
    },
  },
};
</script>

<style scoped>
/* Página y fondo */
.page {
  min-height: 100vh;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  /* padding:  0px 20px; */
  padding-bottom: 20px;
  box-sizing: border-box;
  font-family: Inter, "Segoe UI", Roboto, Arial, sans-serif;
  color: #1f2d3d;
}

.background {
  position: absolute;
  inset: 0;
  background: #020a1a;
  background: linear-gradient(
    236deg,
    rgba(2, 10, 26, 1) 0%,
    rgba(10, 53, 128, 1) 38%,
    rgba(72, 116, 194, 1) 72%,
    rgba(100, 122, 145, 1) 100%
  );
  filter: saturate(110%);
  z-index: 0;
}

/* Card wrapper centra y limita el width */
.card-wrap {
  position: relative;
  z-index: 2;
  width: 100%;
  max-width: 880px;
  display: flex;
  align-items: center;
  flex-direction: column;
}

/* Logo circular sobresaliente */
.logo-pill {
  width: 120px;
  height: 120px;
  border-radius: 50%;
  background-size: cover;
  background-position: center;
  /* border: 6px solid rgba(255, 255, 255, 0.95); */
  /* box-shadow: 0 10px 30px rgba(2, 6, 23, 0.6); */
  transform: translateY(40px);
  /* transform: translateX(-10px); */
  z-index: 6;
  /* background-color: #fff; */
}

/* Card elevado con sombra y efecto 'alto relieve' */
.card-elevated {
  width: 100%;
  border-radius: 14px;
  box-shadow: 0 20px 40px rgba(2, 8, 23, 0.45);
  backdrop-filter: blur(6px);
  border: 1px solid rgba(255, 255, 255, 0.06);
}

/* panel: divide en 2 columnas */
.panel {
  display: flex;
  overflow: hidden;
  border-radius: 10px;
  /* background: transparent; */
}

/* Left image */
.panel-left {
  flex: 1;
  min-width: 250px;
  display: flex;
  align-items: stretch;
  position: relative;
}

.image {
  flex: 1;
  background-size: cover;
  background-position: center;
  min-height: 420px;
  display: flex;
  align-items: center;
  justify-content: center;
  /* padding: 20px; */
  color: #fff;
  position: relative;
}

/* thin overlay for contrast */
.image::before {
  content: "";
  position: absolute;
  inset: 0;
  background: linear-gradient(
    180deg,
    rgba(5, 12, 25, 0.15),
    rgba(5, 12, 25, 0.4)
  );
  pointer-events: none;
}

/* caption on the image */
.image-caption {
  position: relative;
  z-index: 2;
  max-width: 80%;

  background: rgba(0, 0, 0, 0.35); /* color oscuro semitransparente */
  backdrop-filter: blur(8px); /* efecto de desenfoque */
  -webkit-backdrop-filter: blur(8px); /* soporte Safari */
  padding: 20px;
  border-radius: 12px; /* esquinas redondeadas */
  text-align: center;
  max-width: 350px; /* que no sea muy ancho */
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.2); /* sombra suave */
}

.image-caption h3 {
  margin: 0 0 10px;
  font-size: 25px;
  font-weight: 600;
}

.image-caption p {
  margin: 0;
  font-size: 14px;
  color: rgba(255, 255, 255, 0.85); /* texto un poco más suave */
}

.cupos {
  /* margin-top: 10px; */
  margin: 15px auto;
  font-size: 14px;
  color: rgba(255, 255, 255, 0.85); /* texto un poco más suave */
  border: 1px solid rgba(3, 7, 70, 0.664);
  border-radius: 8px;
  display: inline-block; /* se ajusta al texto */
  background: rgba(7, 2, 53, 0.07); /* opcional, toque minimal */
  width: auto;
  max-width: 250px;
  text-align: center;
}

/* Right form */
.panel-right {
  flex: 1;
  min-width: 300px;
  padding: 28px;
  /* background: linear-gradient(
    180deg,
    rgba(255, 255, 255, 0.6),
    rgba(255, 255, 255, 0.5)
  ); */
  background: linear-gradient(
    180deg,
    rgba(255, 255, 255, 0.95),
    rgba(250, 250, 250, 0.9)
  );
  display: flex;
  flex-direction: column;
  gap: 12px;
  border-radius: 12px;
}

/* intro */
.intro h2 {
  margin: 0 0 6px 0;
  font-size: 20px;
  color: #0b2040;
}

/* form elements */
.form {
  margin-top: 6px;
  display: block;
}
.form-group {
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-bottom: 10px;
  font-size: 12px;
  font-weight: bold;
}
.form-group.two {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
  margin-top: 10px;
}
.form-control {
  border-radius: 8px;
  border: 1px solid rgba(16, 30, 50, 0.08);
  padding: 10px 12px;
  background: #fff;
  /* box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.6); */
  box-shadow: none;
  font-size: 13px;
  transition: box-shadow 0.12s ease, border-color 0.12s ease, transform 0.06s;
  outline: none;
}

.form-control:focus {
  border-color: #2b6cb0; /* acento sutil azul */
  box-shadow: 0 6px 18px rgba(43, 108, 176, 0.06);
  transform: translateY(-1px);
}

.form-control[disabled] {
  background: #f7fafc;
  color: #6b7280;
  border-style: solid;
  border-color: rgba(16, 30, 50, 0.04);
}

/* helpers */
.help {
  font-size: 12px;
  font-weight: normal;
  color: #6b7a89;
}
.error {
  font-size: 13px;
  color: #c53030;
  margin-top: 6px;
}

/* buttons */
.actions-row {
  display: flex;
  gap: 12px;
  align-items: center;
  margin: 0px;
}
.actions-row.final {
  display: flex;
  justify-content: center;
  margin-top: 15px;
}

.btn {
  border: none;
  padding: 9px 14px;
  border-radius: 10px;
  cursor: pointer;
  font-weight: 600;
  min-width: 96px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  transition: transform 0.06s ease, box-shadow 0.08s ease, opacity 0.12s;
  background: transparent;
  color: #0b2040;
  border: 1px solid rgba(11, 32, 64, 0.06);
}

/* Primary: plano con sombra sutil */
.btn.primary {
  background: #0b2040;
  color: #fff;
  box-shadow: 0 6px 18px rgba(11, 32, 64, 0.08);
  border: 1px solid rgba(11, 32, 64, 0.08);
}

/* Ghost / outline */
.btn.ghost {
  background: transparent;
  color: #0b2040;
  border: 1px solid rgba(11, 32, 64, 0.08);
}

/* Success (si quieres mantener) */
.btn.success {
  background: #0f8554;
  color: #fff;
  box-shadow: 0 6px 18px rgba(15, 133, 84, 0.08);
  border: 1px solid rgba(15, 133, 84, 0.08);
}

/* Disabled */
.btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
  transform: none;
  box-shadow: none;
}

/* Hover / active */
.btn:not(:disabled):hover {
  transform: translateY(-2px);
}
.btn:active {
  transform: translateY(0);
}

/* spots text */
.spots {
  font-size: 13px;
  color: #344e63;
}

/* small credit below */
.credit {
  margin-top: 12px;
  color: rgba(255, 255, 255, 0.85);
  text-align: center;
  font-size: 13px;
}

/* Responsive: en pantallas pequeñas apilar */
@media (max-width: 880px) {
  .panel {
    flex-direction: column;
  }
  .panel-left,
  .panel-right {
    min-height: auto;
  }
  .image {
    min-height: 200px;
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 0;
  }
  .logo-pill {
    transform: translateY(10px);
    width: 96px;
    height: 96px;
    border-width: 5px;
  }
  .card-elevated {
    padding: 18px;
  }
  .form-group.two {
    grid-template-columns: 1fr;
  }
  .actions-row.final {
    flex-direction: column;
    gap: 10px;
    align-items: stretch;
  }
  .btn {
    width: 100%;
    min-width: auto;
  }
}

/* Mobile very small spacing */
@media (max-width: 420px) {
  .panel-right {
    padding: 18px;
  }
  .form-group.two {
    grid-template-columns: 1fr;
  }
}
/* 
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

nav {
  padding: 30px;
}

nav a {
  font-weight: bold;
  color: #2c3e50;
}

nav a.router-link-exact-active {
  color: #42b983;
} */
</style>
